const dayjs = require('dayjs')

export const isLunchAvailable = (currentOffer, nextOffer) => {
  let hasLunchOffer = false
  currentOffer?.menuItems.forEach(offer => {
    if (dayjs().isSame(offer.day, 'day') || nextOffer) {
      hasLunchOffer = true
    }
  })
  if (nextOffer) hasLunchOffer = true
  return hasLunchOffer
}
